module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-card-smart-edit"
  }, [_c('smart-edit', {
    attrs: {
      "options": _vm.options,
      "value": _vm.item
    },
    on: {
      "input": _vm.updateFields
    }
  }), _c('button', {
    staticClass: "button expanded",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Save and Submit")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e8e446b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/smartedits/WalletEdit.vue
// module id = 2582
// module chunks = 1